"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ArrowDropLeft1_exports = {};
__export(ArrowDropLeft1_exports, {
  default: () => ArrowDropLeft1_default
});
module.exports = __toCommonJS(ArrowDropLeft1_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 6.36328C11.112 6.36328 11.6328 6.14844 12.0625 5.71875C12.5052 5.27604 12.7266 4.7487 12.7266 4.13672C12.7266 3.52474 12.5052 3.00391 12.0625 2.57422C11.6328 2.13151 11.112 1.91016 10.5 1.91016C9.88802 1.91016 9.36068 2.13151 8.91797 2.57422C8.48828 3.00391 8.27344 3.52474 8.27344 4.13672C8.27344 4.7487 8.48828 5.27604 8.91797 5.71875C9.36068 6.14844 9.88802 6.36328 10.5 6.36328ZM10.5 2.90625C10.8385 2.90625 11.125 3.02995 11.3594 3.27734C11.6068 3.51172 11.7305 3.79818 11.7305 4.13672C11.7305 4.47526 11.6068 4.76823 11.3594 5.01562C11.125 5.26302 10.8385 5.38672 10.5 5.38672C10.1615 5.38672 9.86849 5.26302 9.62109 5.01562C9.38672 4.76823 9.26953 4.47526 9.26953 4.13672C9.26953 3.79818 9.38672 3.51172 9.62109 3.27734C9.86849 3.02995 10.1615 2.90625 10.5 2.90625ZM7.375 10.3281C7.51823 10.3281 7.63542 10.2826 7.72656 10.1914C7.81771 10.1003 7.86328 9.98307 7.86328 9.83984V9.15625C7.86328 8.80469 7.99349 8.4987 8.25391 8.23828C8.51432 7.97786 8.82031 7.84766 9.17188 7.84766H11.8281C12.1797 7.84766 12.4857 7.97786 12.7461 8.23828C13.0065 8.4987 13.1367 8.80469 13.1367 9.15625V9.83984C13.1367 9.98307 13.1823 10.1003 13.2734 10.1914C13.3646 10.2826 13.4818 10.3281 13.625 10.3281C13.7552 10.3281 13.8659 10.2826 13.957 10.1914C14.0612 10.1003 14.1133 9.98307 14.1133 9.83984V9.15625C14.1133 8.53125 13.8854 7.9974 13.4297 7.55469C12.987 7.09896 12.4531 6.87109 11.8281 6.87109H9.17188C8.54688 6.87109 8.00651 7.09896 7.55078 7.55469C7.10807 7.9974 6.88672 8.53125 6.88672 9.15625V9.83984C6.88672 9.98307 6.93229 10.1003 7.02344 10.1914C7.1276 10.2826 7.24479 10.3281 7.375 10.3281ZM17.5117 11.0117H3.48828C3.35807 11.0117 3.24089 11.0638 3.13672 11.168C3.04557 11.2591 3 11.3763 3 11.5195C3 11.6497 3.04557 11.7669 3.13672 11.8711C3.24089 11.9622 3.35807 12.0078 3.48828 12.0078H3.82031V13.9805C3.82031 14.332 3.9375 14.638 4.17188 14.8984C4.40625 15.1458 4.69271 15.2826 5.03125 15.3086V17.9062C5.03125 18.0365 5.07682 18.1536 5.16797 18.2578C5.27214 18.349 5.39583 18.3945 5.53906 18.3945C5.66927 18.3945 5.77995 18.349 5.87109 18.2578C5.97526 18.1536 6.02734 18.0365 6.02734 17.9062V17.0469H14.9336V17.9062C14.9336 18.0365 14.9792 18.1536 15.0703 18.2578C15.1745 18.349 15.2917 18.3945 15.4219 18.3945C15.5651 18.3945 15.6823 18.349 15.7734 18.2578C15.8646 18.1536 15.9102 18.0365 15.9102 17.9062V15.3086C16.2617 15.2956 16.5612 15.1589 16.8086 14.8984C17.056 14.638 17.1797 14.332 17.1797 13.9805V12.0078H17.5117C17.6419 12.0078 17.7526 11.9622 17.8438 11.8711C17.9479 11.7669 18 11.6497 18 11.5195C18 11.3763 17.9479 11.2591 17.8438 11.168C17.7526 11.0638 17.6419 11.0117 17.5117 11.0117ZM6.02734 16.0508V15.3086H14.9336V16.0508H6.02734ZM16.2031 13.9805C16.2031 14.0716 16.1641 14.1562 16.0859 14.2344C16.0208 14.2995 15.9427 14.332 15.8516 14.332H5.14844C5.05729 14.332 4.97266 14.2995 4.89453 14.2344C4.82943 14.1562 4.79688 14.0716 4.79688 13.9805V12.0078H16.2031V13.9805Z",
      fill: "currentColor"
    }
  )
);
const SvgArrowDropLeft1 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ArrowDropLeft1_default = SvgArrowDropLeft1;
